import { useEffect, useState } from "react";
import { adminApi, getApiErrorMessage } from "@/lib/api";
import { AdminLayout } from "@/components/layout/AdminLayout";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { formatCurrency, formatDateTime } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";

export default function PaymentsMonitor() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = () => { setLoading(true); return adminApi.get("/admin/payments").then((r) => setPayments(r.data)).finally(() => setLoading(false)); };
  useEffect(() => { load(); }, []);
  const refresh = async (paymentRef) => {
    try {
      const { data } = await adminApi.post(`/admin/payments/${paymentRef}/bse-refresh`);
      toast.success(data.message || `BSE payment status: ${data.live_status || "refreshed"}`);
      await load();
    } catch (error) { toast.error(getApiErrorMessage(error)); }
  };

  return (
    <AdminLayout>
      <div className="mb-6 flex flex-col items-start gap-3 sm:flex-row sm:items-center sm:justify-between"><div><h1 className="font-heading text-3xl text-[var(--brand)]">Payments Monitoring</h1><p className="mt-1 text-sm text-[var(--ink-muted)]">Payment state is read from BSE PG; no local confirmation is available.</p></div><Button variant="outline" size="sm" className="rounded-full" onClick={load}><RefreshCw className="mr-1 h-3.5 w-3.5" /> Refresh</Button></div>
      <Card className="border-[var(--glass-border)]">
        <CardContent className="p-0">
          {loading ? <div className="p-6 text-sm text-[var(--ink-muted)]">Loading payments…</div> : payments.length === 0 ? <div className="p-6 text-sm text-[var(--ink-muted)]" data-testid="admin-no-payments">No payments recorded.</div> :
            <div className="divide-y divide-[var(--glass-border)]">
              {payments.map((p) => (
                <div key={p.payment_ref} className="flex flex-col gap-2 p-4 sm:flex-row sm:items-center sm:justify-between" data-testid={`admin-payment-row-${p.payment_ref}`}>
                  <div>
                    <div className="font-medium">{p.payment_ref}</div>
                    <div className="text-xs text-[var(--ink-muted)]">Client {p.client_code} &middot; {p.mode_of_payment} &middot; {formatDateTime(p.created_at)}</div>
                  </div>
                  <div className="flex flex-wrap items-center gap-2 sm:gap-3">
                    <div className="font-medium">{formatCurrency(p.total_amount)}</div>
                    <Badge variant="outline" className="rounded-full">{p.status}</Badge><Badge className={p.bse2?.status === "SUBMITTED" ? "bg-emerald-600" : p.bse2?.status === "FAILED" ? "bg-red-600" : "bg-amber-600"}>{p.bse2?.live_status || p.bse2?.status || "NOT SENT"}</Badge>
                    {(p.bse2?.payment_ref_id || p.bse2?.bse_order_ids?.length) && <Button size="sm" variant="outline" className="rounded-full" onClick={() => refresh(p.payment_ref)}><RefreshCw className="mr-1 h-3.5 w-3.5" /> BSE status</Button>}
                  </div>
                </div>
              ))}
            </div>}
        </CardContent>
      </Card>
    </AdminLayout>
  );
}
